var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_064-kitchen-1",
    "data-name": "064-kitchen-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.405,
    height: 98.405,
    viewBox: "0 0 98.405 98.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_219",
    "data-name": "Trazado 219",
    d: "M96.765,96H67.243a1.64,1.64,0,0,0-1.64,1.64v37.722H29.521v-4.92a1.64,1.64,0,0,0-1.64-1.64h-4.92v3.28h3.28v3.28h-6.56V128.8H16.4v6.56H9.84v-3.28h3.28V128.8H8.2a1.64,1.64,0,0,0-1.64,1.64v4.92H1.64A1.64,1.64,0,0,0,0,137v36.082a1.64,1.64,0,0,0,1.64,1.64H96.765a1.64,1.64,0,0,0,1.64-1.64V97.64A1.64,1.64,0,0,0,96.765,96ZM68.883,99.28H95.125v19.681H68.883ZM65.6,145.2H36.082v-6.56H65.6ZM3.28,138.642H32.8v6.56H3.28Zm0,9.84H32.8v22.961H3.28Zm32.8,0H49.2v22.961H36.082Zm16.4,0H65.6v22.961H52.483Zm16.4,22.961v-49.2H95.125v49.2Zm0,0",
    transform: "translate(0 -76.319)",
    fill: "#003082"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_220",
    "data-name": "Trazado 220",
    d: "M352,144h3.28v6.56H352Zm0,0",
    transform: "translate(-279.837 -114.479)",
    fill: "#86888b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_221",
    "data-name": "Trazado 221",
    d: "M352,256h3.28v6.56H352Zm0,0",
    transform: "translate(-279.837 -203.517)",
    fill: "#86888b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_222",
    "data-name": "Trazado 222",
    d: "M35.28,313.64A1.64,1.64,0,1,1,33.64,312,1.64,1.64,0,0,1,35.28,313.64Zm0,0",
    transform: "translate(-25.44 -248.037)",
    fill: "#86888b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_223",
    "data-name": "Trazado 223",
    d: "M67.28,313.64A1.64,1.64,0,1,1,65.64,312,1.64,1.64,0,0,1,67.28,313.64Zm0,0",
    transform: "translate(-50.879 -248.037)",
    fill: "#86888b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_224",
    "data-name": "Trazado 224",
    d: "M99.28,313.64A1.64,1.64,0,1,1,97.64,312,1.64,1.64,0,0,1,99.28,313.64Zm0,0",
    transform: "translate(-76.319 -248.037)",
    fill: "#86888b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_225",
    "data-name": "Trazado 225",
    d: "M131.28,313.64a1.64,1.64,0,1,1-1.64-1.64A1.64,1.64,0,0,1,131.28,313.64Zm0,0",
    transform: "translate(-101.759 -248.037)",
    fill: "#86888b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_226",
    "data-name": "Trazado 226",
    d: "M1.64,31.162h32.8a1.64,1.64,0,0,0,1.64-1.64V24.6a1.64,1.64,0,0,0-.48-1.16l-6.56-6.56a1.64,1.64,0,0,0-1.16-.48h-1.64V1.64A1.64,1.64,0,0,0,24.6,0H11.481A1.64,1.64,0,0,0,9.84,1.64V16.4H8.2a1.64,1.64,0,0,0-1.16.48L.48,23.442A1.64,1.64,0,0,0,0,24.6v4.92A1.64,1.64,0,0,0,1.64,31.162ZM13.121,3.28h9.84V16.4h-9.84Zm-9.84,22,5.6-5.6H27.2l5.6,5.6v2.6H3.28Zm0,0",
    transform: "translate(0 0)",
    fill: "#003082"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_227",
    "data-name": "Trazado 227",
    d: "M53.321,368H33.64A1.64,1.64,0,0,0,32,369.64v13.121a1.64,1.64,0,0,0,1.64,1.64H53.321a1.64,1.64,0,0,0,1.64-1.64V369.64A1.64,1.64,0,0,0,53.321,368Zm-1.64,13.121H35.28V371.28h16.4Zm0,0",
    transform: "translate(-25.44 -292.556)",
    fill: "#86888b"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_228",
    "data-name": "Trazado 228",
    d: "M232,312h6.56v3.28H232Zm0,0",
    transform: "translate(-184.438 -248.037)",
    fill: "#86888b"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_229",
    "data-name": "Trazado 229",
    d: "M208,392h3.28v6.56H208Zm0,0",
    transform: "translate(-165.358 -311.636)",
    fill: "#86888b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_230",
    "data-name": "Trazado 230",
    d: "M272,392h3.28v6.56H272Zm0,0",
    transform: "translate(-216.237 -311.636)",
    fill: "#86888b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_231",
    "data-name": "Trazado 231",
    d: "M185.64,41h9.84a1.64,1.64,0,0,0,1.64-1.64v-1.64a6.56,6.56,0,0,0-4.92-6.327V0h-3.28V31.394A6.56,6.56,0,0,0,184,37.722v1.64A1.64,1.64,0,0,0,185.64,41Zm4.92-6.56a3.28,3.28,0,0,1,3.28,3.28h-6.56A3.28,3.28,0,0,1,190.56,34.441Zm0,0",
    transform: "translate(-146.278 0)",
    fill: "#86888b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_232",
    "data-name": "Trazado 232",
    d: "M241.64,27.881h9.84a1.64,1.64,0,0,0,1.64-1.64V24.6a6.56,6.56,0,0,0-4.92-6.327V0h-3.28V18.274A6.56,6.56,0,0,0,240,24.6v1.64A1.64,1.64,0,0,0,241.64,27.881Zm4.92-6.56a3.28,3.28,0,0,1,3.28,3.28h-6.56A3.28,3.28,0,0,1,246.56,21.321Zm0,0",
    transform: "translate(-190.798 0)",
    fill: "#86888b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.2635cbb6ba1a936b414391e88510d69f.svg";
export { ForwardRef as ReactComponent };